import type { ZodType } from 'zod';

export function parseResponse<T>(
  schema: ZodType<T>,
  data: unknown,
  name: string,
): T {
  const parsed = schema.safeParse(data);
  if (!parsed.success) {
    console.error(`The ${name} response failed validation`, parsed.error);
    throw new Error(`The ${name} data could not be read.`);
  }
  return parsed.data;
}
